import React, { useEffect, useState } from "react";

import styles from "./imageEmployee.module.css";
import { Icon, Modal } from "antd";
import { getEmployeePhotoById } from "../../../../../../components/http.request";

interface ImageEmployeeProps {
    id: string | null;
}

export function ImageEmployee({ id }: ImageEmployeeProps) {
    const [imageContent, setImageContent] = useState<string | null>(null);
    const [preview, setPreview] = useState<boolean>(false);
    const [loadingImage, setLoadingImage] = useState<boolean>(true);

    useEffect(() => {
        if (!id) return;

        getEmployeePhotoById(id)
            .then((result) => {
                if (result) {
                    setImageContent(result);
                }
            })
            .finally(() => {
                setLoadingImage(false);
            });
    }, [id]);

    console.log("id employeweeeeeeee:", id);

    function handlePreviewImage() {
        setPreview(true);
    }

    function handleCancelPreviewImage() {
        setPreview(false);
    }

    return (
        <>
            <div className={styles.divRoot}>
                <div
                    className={styles["div-image"]}
                    style={{
                        cursor: imageContent ? "pointer" : "default",
                    }}
                >
                    {loadingImage ? (
                        <Icon type={"loading"} style={{ fontSize: 32 }} />
                    ) : imageContent ? (
                        <img
                            src={imageContent}
                            alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                cursor: imageContent ? "pointer" : "initial",
                                objectFit: "contain",
                            }}
                        />
                    ) : (
                        <Icon type={"user"} style={{ fontSize: 32 }} />
                    )}
                </div>
                {imageContent && (
                    <div className={styles["image-root-hover"]}>
                        <div className={styles["div-image-hover"]} onClick={handlePreviewImage}>
                            <Icon type="eye" style={{ color: "#fff" }} />
                        </div>
                    </div>
                )}
            </div>
            {preview && imageContent && (
                <Modal visible footer={null} onCancel={handleCancelPreviewImage}>
                    <img alt="" style={{ width: "100%" }} src={imageContent!} />
                </Modal>
            )}
        </>
    );
}
